import { gql } from '@apollo/client'

export const GET_COACH_AVAILABILITY_OVERRIDES = gql`
  query CoachAvailabilityOverrides($dateRange: DateRangeInput) {
    coachAvailabilityOverrides(dateRange: $dateRange) {
      id
      date
      coachFacility {
        id
        name
      }
      timeSlots {
        startTime
        endTime
      }
    }
  }
`

export const SET_COACH_AVAILABILITY_OVERRIDE = gql`
  mutation SetCoachAvailabilityOverride(
    $coachFacilityId: ID!
    $input: SetCoachAvailabilityOverrideInput!
  ) {
    setCoachAvailabilityOverride(
      coachFacilityId: $coachFacilityId
      input: $input
    ) {
      success
      message
      coachAvailabilityOverride {
        id
        date
        coachFacility {
          id
          name
        }
        timeSlots {
          startTime
          endTime
        }
      }
    }
  }
`

export const REMOVE_COACH_AVAILABILITY_OVERRIDE = gql`
  mutation RemoveCoachAvailabilityOverride($id: ID!) {
    removeCoachAvailabilityOverride(id: $id) {
      success
      message
    }
  }
`
